import TaskRow from "./TaskRow";
import { Task } from "axiosApi/models";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Box,
} from "@mui/material";
import intl from "components/i18n/ReactIntlWrapper";

export type TaskListProps = {
  tasksByJob: Task[];
  handleTaskEdit: Function;
  handleTaskDelete: Function;
  isTaskEditMode: Function;
};
const TaskList = ({
  tasksByJob,
  handleTaskEdit,
  handleTaskDelete,
  isTaskEditMode,
}: TaskListProps) => {
  return (
    <Box sx={{ overflowX: "auto", mt: 2 }}>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{intl.get("taskList.table.thead.task")}</TableCell>
              <TableCell>{intl.get("taskList.table.thead.jira")}</TableCell>
              <TableCell align="center">
                {intl.get("taskList.table.thead.actions")}
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {tasksByJob?.map((task) => (
              <TaskRow
                key={task.id}
                idTask={task.id}
                description={task.description}
                idJira={task.idJira}
                handleTaskEdit={handleTaskEdit}
                handleTaskDelete={handleTaskDelete}
                isTaskEditMode={isTaskEditMode}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TaskList;
